export default __webpack_public_path__ + "static/media/tax_2.7928a9bf.jpg";